import { render, staticRenderFns } from "./Hoteles.vue?vue&type=template&id=2e677227&"
import script from "./Hoteles.vue?vue&type=script&lang=js&"
export * from "./Hoteles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports